export enum ReportRunActionType {
  PollReportRun = 'PollReportRun',
  PollReportRunFailed = 'PollReportRunFailed',
  ExecuteReportRun = 'ExecuteReportRun',
  ExecuteReportRunSuccess = 'ExecuteReportRunSuccess',
  ExecuteReportRunFailed = 'ExecuteReportRunFailed',
  ExecutePreviewTableQueryRun = 'ExecutePreviewTableQueryRun',
  CancelPollReportRun = 'CancelPollReportRun',
  CancelQueryRun = 'CancelQueryRun',
  ReportRunLoadSuccess = 'ReportRunLoadSuccess',
  ReportRunLoadFailure = 'ReportRunLoadFailure',
  PollReportRunComplete = 'PollReportRunComplete',
  LoadQueryRunView = 'LoadQueryRunView',
  LoadQueryRunSuccess = 'LoadQueryRunSuccess',
  LoadQueryRunFailure = 'LoadQueryRunFailure',
  LoadQueryResultSuccess = 'LoadQueryResultSuccess',
  LoadQueryResultFailure = 'LoadQueryResultFailure',
  ReportRoutesNoScriptOrLegacy = '[Report Routes] Report Has No Script Or Legacy Charts',
  LoadCsvSuccess = 'LoadCsvSuccess',
  RefreshReportRunAfterCellExport = 'RefreshReportRunAfterCellExport',
}
